import { render, staticRenderFns } from "./MiddleEast.vue?vue&type=template&id=11530076&scoped=true&"
import script from "./MiddleEast.vue?vue&type=script&lang=js&"
export * from "./MiddleEast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11530076",
  null
  
)

export default component.exports